import React from "react";
import './about.style.scss';
import Footer from '../../components/footer/footer.comp';
import Navbar from '../../components/navbar/navbar.comp';

const About = () => {

    return (

        <div>
            {/* Navbar */}
            < div className='section' >
                <Navbar />
            </div >

            {/* Main Section */}
            <div className='section text-section frame about'
                style={{ color: 'var(--fontlightblack1)', textAlign: 'left' }}
            >
                <h1 style={{ textAlign: 'left', color: 'var(--fontlightblack1)' }}>About Reach</h1>
                <p>Fun and Easy challenges to get you going!</p>
                <p>Reach is a platform designed to make advice and knowledge more practical and actionable, offering step-by-step challenges that turn guidance into real-world experiences especially for <strong>those who learn best by doing</strong>.</p>
                <div style={{ display: 'flex', gap: '2px', marginTop: '40px', marginBottom: '80px' }}>
                    <p style={{ color: 'var(--fontgrey)', fontWeight: 300, fontSize: '40px', margin: 0 }}>R</p>
                    <div
                        style={{
                            backgroundImage: `url(${'https://firebasestorage.googleapis.com/v0/b/glu-mvp.appspot.com/o/logo.png?alt=media&token=cf979f66-db82-4439-bb39-2cc5240d39d3'})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            // height: '200px',
                            aspectRatio: '1/1',
                            height: '60px',
                            marginLeft: '0',
                        }}
                    />
                    <p style={{ color: 'var(--fontgrey)', fontWeight: 300, fontSize: '40px', margin: 0 }}>ACH</p>
                </div>
            </div>

            {/* Footer Margin */}
            <div style={{ height: '300px' }} className="footer-margin">
            </div>

            {/* Footer */}
            <Footer />
        </div >
    );
};

export default About;